<template>
  <div id="capacity-container">
    <div class="user-info__item space-info" style="margin-top: 4px;">
      <div class="user-info__label">空间：</div>
      <div class="user-info__container">
        <div class="space-process"
              :class="{'is-warning': (((+capacity.usedCapacity) + (+capacity.allOtherUsedCapacity)) / capacity.totalCapacity * 100) > 90}">
          <div class="person-space" style="width: 100%;" v-if="(((+capacity.usedCapacity) + (+capacity.allOtherUsedCapacity)) / capacity.totalCapacity * 100) > 100"></div>
          <template v-else>
            <div class="person-space"
                  :style="{
                  width: (capacity.usedCapacity / capacity.totalCapacity * 100) + '%'
                }"></div>
            <!-- <el-tooltip :disabled="!capacity.allOtherUsedCapacity"
                        popper-class="custom-tooltip__style"
                        placement="bottom"
                        effect="light"
                        :visible-arrow="false"
                        :offset="0"
                        v-if="![1, 0].includes(userInfo.accountType)"
                        style="border: 0 !important;">
              <div slot="content">
                其他文件 {{capacity.allOtherUsedCapacity}}G
              </div>
              <div class="enterprise-space"
                    :style="{
                    width: (((+capacity.usedCapacity) + (+capacity.allOtherUsedCapacity)) / capacity.totalCapacity * 100) + '%'
                  }"></div>
            </el-tooltip> -->
          </template>
        </div>
        <div class="capacity-info">
          {{capacity.usedCapacity}}G / {{capacity.totalCapacity}}G
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCookie } from '@/utils'
import { unescape } from 'lodash'
export default {
  data () {
    return {
      capacity: {
        totalCapacity: 0, // 总容量
        usedCapacity: 0, // 已使用容量
        residualCapacity: 0, // 剩余容量
        allOtherUsedCapacity: 0 // 其他员工使用容量
      }
    }
  },
  mounted () {
    this.fetchWorkspaceCapacity()
  },
  methods: {
    // 获取用户空间容量使用情况
    async fetchWorkspaceCapacity () {
      // 必须转换，要不然会报错。
      const subAccountInfo = decodeURIComponent(
        unescape(getCookie('subAccountInfo'))
      )
      const { gldToken: subGldToken } = JSON.parse(subAccountInfo) 
      const gldToken =  subAccountInfo ?  subGldToken : getCookie('gldToken')
      if (!gldToken) {
        console.error('空间容量：暂无gldToken')
        return false
      }
      const data = await this.$api.user.getWorkspaceCapacity({ gldToken })
      console.log(data)
      const obj = {
        workspaceId: 0,
        totalCapacity: 0, // 总容量
        usedCapacity: 0, // 已使用容量
        residualCapacity: 0, // 剩余容量
        allOtherUsedCapacity: 0 // 其他员工使用容量
      }
      Object.assign(obj, data || {})
      // 企业员工 空间使用量 单位为G
      const unit = 1024 * 1024 * 1024
      // 个人账号 空间使用量 单位为M
      // if (accountType === 0) {
      //   unit = 1024 * 1024
      // }
      let { totalCapacity, usedCapacity, allOtherUsedCapacity, residualCapacity } = obj
      totalCapacity = Math.abs(+totalCapacity / unit).toFixed(2)
      usedCapacity = (+usedCapacity / unit)
      allOtherUsedCapacity = (+allOtherUsedCapacity / unit)
      if (usedCapacity < 0.01) {
        usedCapacity = 0
      } else {
        usedCapacity = usedCapacity.toFixed(2)
      }
      if (allOtherUsedCapacity < 0.01) {
        allOtherUsedCapacity = 0
      } else {
        allOtherUsedCapacity = allOtherUsedCapacity.toFixed(2)
      }
      Object.assign(this.capacity, {
        totalCapacity: totalCapacity || 0,
        usedCapacity: usedCapacity || 0,
        residualCapacity,
        allOtherUsedCapacity: allOtherUsedCapacity || 0
      })
      console.log(this.capacity)
    }
  }
}
</script>

<style lang="scss" scoped>
#capacity-container{
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .space-info{
    flex: 1;
    display: flex;
    .user-info__label{
      font-size: 12px;
      font-weight: 400;
      color: rgba(31,31,31,0.55);
    }
    .user-info__container{
      flex: 1;
      .space-process {
        flex: 1;
        /*width: 132px;*/
        height: 6px;
        margin-top: 7px;
        background: rgba(33, 37, 48, 0.1);
        /*display: flex;*/
        position: relative;
        border-radius: 3px;
        &.is-warning {
          .person-space {
            background: #DF4952;
          }
          .enterprise-space {
            background: #FFBDC1;
          }
        }

        .person-space {
          position: absolute;
          height: 6px;
          border-radius: 3px;
          background: #C2DEFF;
          z-index: 2;
        }

        .enterprise-space {
          position: absolute;
          height: 6px;
          border-radius: 3px;
          background: #C2DEFF;
          z-index: 1;
        }
      }

      .capacity-info {
        height: 22px;
        font-size: 12px;
        font-weight: 400;
        color: #595959;
        line-height: 22px;
      }
    }

  }
}
</style>
